export default class Test {
  id;
  title;
  category;
  dependedTestIds;
  dominant_only;
  duration;
  laterality;
  protocol;
  mux_link;
  video_link;
  testItems;

  constructor({
    id,
    title,
    category,
    dependedTestIds,
    dominant_only,
    duration,
    laterality,
    protocol,
    mux_link,
    video_link,
    testItems
  }) {
    this.id = id;
    this.title = title;
    this.category = category;
    this.dependedTestIds = dependedTestIds;
    this.dominant_only = dominant_only;
    this.duration = duration;
    this.laterality = laterality;
    this.protocol = protocol;
    this.mux_link = mux_link;
    this.video_link = video_link;
    this.testItems = testItems;
  }
}
